const inline = (s) =>
  s.split(/(\*\*[^*]+\*\*)/g).map((part, i) =>
    part.startsWith("**") && part.endsWith("**") ? <strong key={i}>{part.slice(2, -2)}</strong> : part
  );

export const SectionBody = ({ text }) => {
  const blocks = [];
  let list = [];
  const flush = () => {
    if (list.length) blocks.push(<ul key={`u${blocks.length}`}>{list}</ul>);
    list = [];
  };
  text.split("\n").forEach((raw, i) => {
    const line = raw.trim();
    if (!line) return flush();
    const bullet = line.match(/^[-*•]\s+(.*)$/);
    if (bullet) list.push(<li key={i}>{inline(bullet[1])}</li>);
    else {
      flush();
      blocks.push(<p key={i}>{inline(line.replace(/^#+\s*/, ""))}</p>);
    }
  });
  flush();
  return <div className="rf-body text-[15px] leading-relaxed">{blocks}</div>;
};
